export const EVALUATION_MODEL_STEPS = [
	{ label: 'Escoge Puestos' },
	{ label: 'Destrezas Requeridas' },
	{ label: 'Competencias Requeridas' },
	{ label: 'Preguntas' },
];
export const PROCESS_MODEL_STEPS = [
	{ label: 'Configurar Proceso' },
	{ label: 'Escoger Empleados' },
	{ label: 'Escoger Evaluadores' },
];
export default {};



// WEBPACK FOOTER //
// ./src/modules/evaluation-360/constants/constants.js